import { ButtonVariant, ButtonProps, ActionIcon } from '@mantine/core';
import cx from 'clsx';
import { MouseEvent, ReactNode } from 'react';

import classes from './ActionIconButton.module.scss';

type ActionIconButtonProps = {
  onClick: (Event: MouseEvent) => void;
  variant?: ButtonVariant;
  Icon: ReactNode;
  size?: number;
  className?: string;
  isDisabled?: boolean;
  dataTestId?: string;
} & ButtonProps;

export const ActionIconButton = (props: ActionIconButtonProps) => {
  const { onClick, size = 24, variant = 'transparent', Icon, className, isDisabled, dataTestId } = props;

  return (
    <ActionIcon
      size={size}
      onClick={onClick}
      variant={variant}
      disabled={isDisabled}
      className={cx(classes.actionIconButton, className)}
      data-testid={dataTestId}
    >
      {Icon}
    </ActionIcon>
  );
};
